import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { FAQS } from "@/lib/data";

const Faq = () => (
  <section id="faq" className="relative py-24 sm:py-32 bg-[#0E142B]/50 border-t border-[#D4AF37]/10">
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="Good to Know"
        title={
          <>
            Everything, <em className="text-gold-gradient italic">thought of</em>
          </>
        }
        sub="Pricing, parking, policies, and what to expect — answered before you even ask."
      />
      <Reveal className="mt-14">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-accordion-item-${i + 1}`}
              className="border border-white/10 bg-[#131B36]/70 rounded-2xl px-6 border-b"
            >
              <AccordionTrigger className="text-left text-[#F8F9FA] hover:text-[#F3D068] hover:no-underline py-5 text-sm sm:text-base font-medium">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#C5CEE0] font-light leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
